
import ItineraryList from "../ItineraryList";
import SelectedItinerary from "../SelectedItinerary";
import LoginForm from "../../../LoginPage/Components/LoginForm";
import SignupForm from "../../../LoginPage/Components/SignupForm";

const PrivateItineraries = (props) => {

    const {
         isLoggedIn,
         isShowSignUpForm,
         LogMeIn,
         setIsShowSignUpForm,
         currentPage,
         _SUB_PAGES,
         pageFilters,
         user,
         setSelectedItinerary,
         setCurrentPage,
         selectedItinerary,
         bookingEngine,
    } = props;

    return <div>
        {
            (bookingEngine?._id) &&
            <div>
                {
                    isLoggedIn ?
                    <p style={{display: "none", backgroundColor: "green", color: "white", fontSize: 13, padding: 10}}>
                        <i style={{color: "yellow", marginRight: 10}} className="fa-solid fa-info"></i>
                        You're Logged in!
                    </p> :
                    <p style={{backgroundColor: "crimson", color: "white", fontSize: 13, padding: 10}}>
                        <i style={{color: "orange", marginRight: 10}} className="fa-solid fa-exclamation-triangle"></i>
                        You're Not Logged in!
                    </p>
                }
                {
                    !isLoggedIn ? 
                    <div className="wrapper">
                        <LoginForm 
                            isLoggedIn={isLoggedIn} 
                            isShowSignUpForm={isShowSignUpForm}
                            LogMeIn={LogMeIn}
                            showSignupForm={()=>setIsShowSignUpForm(true)}
                            bookingEngine={bookingEngine}
                        /> 
                        <SignupForm
                            LogMeIn={LogMeIn}
                            isLoggedIn={isLoggedIn}
                            isShowSignUpForm={isShowSignUpForm}
                            showLoginForm={()=>setIsShowSignUpForm(false)}
                            bookingEngine={bookingEngine}
                        />
                    </div> :
                    <>
                        {
                            (currentPage===_SUB_PAGES?.view_list) &&
                            <div className="wrapper">
                                <ItineraryList 
                                    pageFilters={pageFilters}
                                    userDetails={user}
                                    setSelectedItinerary={(_itin_item)=>{
                                        setSelectedItinerary(_itin_item);
                                        setCurrentPage(_SUB_PAGES?.view_details);
                                    }}
                                    bookingEngine={bookingEngine}
                                />
                            </div>
                        }
                        {
                            (currentPage!==_SUB_PAGES?.view_list && selectedItinerary?._id) &&
                            <SelectedItinerary 
                                userDetails={user}
                                itinerary={selectedItinerary}
                                setItinerary={setSelectedItinerary}
                                bookingEngine={bookingEngine}
                            />
                        }
                    </>
                }
            </div>
        }
    </div>
}

export default PrivateItineraries;